import { createSelector } from 'reselect'

const changeFolderColorSelector = createSelector(
	[state => state.libraries.current],
	current => ({
		libraryUID: current.libraryUID,
		folderUID: current.folderUID,
		folderName: current.name,
		parentId: current.folderUID,
	})
)

export default changeFolderColorSelector
